import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Header from '../components/Header';
import MarkDown from '../components/MarkDown';
import Footer from '../components/Footer';
import { AdIcons } from '../components/Ad';
import '../blog.css';
import '../journal.css';
import {
  DEFAULT_IMAGE,
  extractMarkdownMetadata,
  fetchStaticMarkdown,
} from '../utils/markdownContent';

function Journal() {
  const { id } = useParams();
  const [title, setTitle] = useState('聖書新聞 - ASMRキリスト教会');
  const [description, setDescription] = useState('ASMRキリスト教会の聖書新聞記事');
  const [image, setImage] = useState('https://www.asmrchurch.com/static/images/i4.jpg');

  useEffect(() => {
    if (!id) {
      return undefined;
    }

    let isMounted = true;

    const fetchMetadata = async () => {
      try {
        const text = await fetchStaticMarkdown(`/journal/${id}`);
        if (!isMounted) {
          return;
        }

        const metadata = extractMarkdownMetadata(text, {
          description: 'ASMRキリスト教会の聖書新聞記事',
        });
        const resolvedTitle = metadata.title
          ? `${metadata.title} - 聖書新聞 - ASMRキリスト教会`
          : '聖書新聞 - ASMRキリスト教会';
        setTitle(resolvedTitle);
        setDescription(metadata.description || 'ASMRキリスト教会の聖書新聞記事');
        setImage(metadata.image || DEFAULT_IMAGE);
      } catch (error) {
        console.error(error);
        if (isMounted) {
          setTitle('聖書新聞 - ASMRキリスト教会');
          setDescription('ASMRキリスト教会の聖書新聞記事');
          setImage(DEFAULT_IMAGE);
        }
      }
    };

    fetchMetadata();

    return () => {
      isMounted = false;
    };
  }, [id]);

  const url = `https://www.asmrchurch.com/journal/${id}`;

  return (
    <div className="journal-page">
      <Header
        title={title}
        description={description}
        url={url}
        image={image}
      />
      <div className="flex-container journal-layout">
        <div className="left-area">
          <AdIcons />
        </div>
        <div className="cont2 journal-content">
          <MarkDown
            articleType="journal"
            articleId={id}
            fallbackPath={`/journal/${id}`}
          />
          <a href="/journal">聖書新聞一覧</a>
          <div className="return" />
          <div className="mobile-ads">
            <AdIcons />
          </div>
        </div>
        <div className="right-area">
          <span className="pad">
            {/*
            <stripe-buy-button
              buy-button-id="buy_btn_1QiEyXJrEFc0aoshZrg6uGA0"
              publishable-key="pk_live_51L77y9JrEFc0aoshDbT8faRDJBWQJjQTGvMb6jngK3GGGpMtIYf8omncPkMd8e0be0ZsfG2yEWaxYdMSlGSS9pgX00RNzmWvfw"
            >
            </stripe-buy-button>
            */}
          </span>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Journal;
